import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class CorporateService {
  ref = firebase.firestore().collection('users');
  private roleCollection: any;
  private budgetCollection: any;
  private roomCollection: any;
  private groupCollection: any;
  private banquetCollection: any;
  private linkedCorporateCollection: any;
  private tripSummaryCollection: any;
  private budgetMasterCollection: any;
  allDepartments: any = [];
  allDivisions: any = [];
  allPurposes: any = [];

  constructor(
    private firestore: AngularFirestore,
    public afs: AngularFirestore,
    private httpService: HttpClient
  ) {
    this.roomCollection = this.afs.collection<any>('room');
    this.budgetCollection = this.afs.collection<any>('corpBudget');
    this.groupCollection = this.afs.collection<any>('group');
    this.banquetCollection = this.afs.collection<any>('banquet');

    this.linkedCorporateCollection = this.afs.collection<any>('linkedCorps');
    this.tripSummaryCollection = this.afs.collection<any>('tripSummary');
    this.budgetMasterCollection = this.afs.collection<any>('budgetMaster');
  }

  addBudgetMasterData(data: any) {
    console.log('budgetMasterCollection :', this.budgetMasterCollection);
    data.timeStamp = moment().format('x');
    return firebase.firestore().collection('budgetMaster').add(data);
  }

  initProviders(corpId: any) {
    this.getDepartmentsByCorpId(corpId)
      .then((res: any) => {
        console.log('got default departmentList ', res);
        this.allDepartments = res[0].departmentList || [];
        this.allDepartments.push('Others');
        console.log('this.allDepartments', this.allDepartments);
        return this.getDivisionByCorpId(corpId);
      })
      .then((res: any) => {
        this.allDivisions = res[0].divisionList || [];
        this.allDivisions.push('Others');
        return this.getPurposeByCorpId(corpId);
      })
      .then((res: any) => {
        this.allPurposes = res[0].purposeList || [];
        this.allPurposes.push('Others');
      });
  }

  getSubscriptionByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('subscription', (ref) =>
          ref.where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getDepartmentsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('corpDepartments', (ref) =>
          ref.where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getDivisionByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('corpDivision', (ref) => ref.where('corpId', '==', corpId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPurposeByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('corpPurpose', (ref) => ref.where('corpId', '==', corpId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getBudgetMasterData() {
    return new Promise((resolve) => {
      this.firestore
        .collection('budgetMaster')
        .snapshotChanges()
        .subscribe((responseData) => {
          console.log('responseData: ', responseData);
          const budgetData = responseData.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(budgetData);
        });
    });
  }

  generateUniqNumber(length?: any) {
    var length = length || 8,
      charset = '0123456789',
      retVal = '';
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  updateCorporate(uid: string, user: any) {
    user.timeStamp = moment().format('x');
    return this.afs.doc('corporate/' + uid).set(user);
  }

  addCorporate(data: any) {
    data.timeStamp = moment().format('x');
    return firebase.firestore().collection('corporate').add(data);
  }

  addTripSummary(data: any) {
    data.timeStamp = moment().format('x');
    return firebase.firestore().collection('tripSummary').add(data);
  }

  addCorporatePolicy(data: any) {
    data.timeStamp = moment().format('x');
    return firebase.firestore().collection('corppolicies').add(data);
  }

  updateCorporatePolicy(data: any) {
    data.timeStamp = moment().format('x');
    return this.afs.doc('corppolicies/' + data.id).set(data);
  }

  // getCorpUsersPolicyById(corpId: any) {
  //   return new Promise((resolve) => {
  //     this.firestore.collection('corppolicies', (ref) =>
  //       ref
  //         .where("corpId", "==", corpId)
  //     ).snapshotChanges()
  //       .subscribe(corppolicies => {
  //         let contactList = corppolicies.map(item => {
  //           return {
  //             ...item.payload.doc.data() as {},
  //             id: item.payload.doc.id
  //           };
  //         });
  //         resolve(contactList);
  //       })
  //   })
  // }
  // updateCorporatePolicy(id: string, data: any) {
  //   data.timeStamp = moment().format('x')
  //   return this.afs.doc('corppolicies/' + id).set(data);
  // }

  addLinkedCorporate(data: any) {
    data.timeStamp = moment().format('x');
    return firebase.firestore().collection('linkedCorps').add(data);
  }

  addNewRoomrequest(data: any) {
    data.timeStamp = moment().format('x');
    return this.roomCollection.add(data);
  }

  addCorpBudget(data: any) {
    return this.budgetCollection.add(data);
  }

  updateCorpBudget(data: any) {
    return this.afs.doc('corpBudget/' + data.id).set(data);
  }

  addNewGrouprequest(data: any) {
    data.timeStamp = moment().format('x');
    return this.groupCollection.add(data);
  }

  updateLinkClient(data: any) {
    data['timeStamp'] = moment().format('x');
    return this.afs.doc('linkclients/' + data.id).set(data);
  }

  addNewBanquetRequest(data: any) {
    data.timeStamp = moment().format('x');
    return this.banquetCollection.add(data);
  }

  updateRoom(data: any) {
    data.timeStamp = moment().format('x');
    return this.afs.doc('group/' + data.id).set(data);
  }

  updateGroupData(data: any) {
    data.timeStamp = moment().format('x');
    return this.afs.doc('group/' + data.id).set(data);
  }

  updateGroupData1(uid: any, data: any) {
    data.timeStamp = moment().format('x');
    return this.afs.doc('group/' + uid).update({
      travellerDetials: data,
    });
  }

  updateMultiGroupData(data: any) {
    data.timeStamp = moment().format('x');
    return firebase.firestore().collection('multiGroup').add(data);
  }

  upsertMultiGroupData(data: any) {
    data.timeStamp = moment().format('x');
    return this.afs.doc('multiGroup/' + data.id).set(data);
  }

  getMultiGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('multiGroup', (ref) =>
          ref.where('status', '==', 'Booked').where('hotelId', '==', hotelId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorpUsersById(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('admins', (ref) => ref.where('corpId', '==', corpId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorpBudgetList(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('corpBudget', (ref) => ref.where('corpId', '==', corpId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getMultiGroupsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('multiGroup', (ref) => ref.where('corpId', '==', corpId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAmendGroupList(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('requestType', '==', 'Amendment')
            .where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAmendBanquetList(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('requestType', '==', 'Amendment')
            .where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCancelGroupList(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref.where('requestType', '==', 'Cancel').where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCancelBanquetList(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref.where('requestType', '==', 'Cancel').where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAcceptedGroupsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref.where('status', '==', 'Approved').where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingPayGroupsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', '==', 'HTL_UPDATE_TARIFF')
            .where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorpPaidGroupsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', '==', 'CORP_PAID')
            .where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorpPaidGroupsByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', '==', 'CORP_PAID')
            .where('reqById', '==', userId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAcceptedGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref.where('status', '==', 'Accepted').where('hotelId', '==', hotelId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  updateBanquetData(data: any) {
    data.timeStamp = moment().format('x');
    return this.afs.doc('banquet/' + data.id).set(data);
  }

  updateRoomData(data: any) {
    data.timeStamp = moment().format('x');
    return this.afs.doc('room/' + data.id).set(data);
  }

  getGroupByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) => ref.where('corpId', '==', corpId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorporateUsers(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('admins', (ref) => ref.where('corpId', '==', corpId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorporateTripSummary(corpId: any, startDate, endDate) {
    return new Promise((resolve) => {
      this.firestore
        .collection('tripSummary', (ref) =>
          ref
            .where('corpId', '==', corpId)
            // .orderBy("timeStamp", "desc")
            .where('status', 'in', ['Approved', 'confirmed', 'Confirmed'])
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getHotelWiseExpenses(corpId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('tripSummary', (ref) =>
        ref.where("corpId", "==", corpId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getCorporateRoomRequestSummary(corpId: any, startDate, endDate) {
    return new Promise((resolve) => {
      this.firestore.collection('room', (ref) =>
        ref.where("corpId", "==", corpId)
          // .orderBy("timeStamp", "desc")
          .where("status", "in", ['Approved','Rejected'])
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getCorporateGroupRequestSummary(corpId: any, startDate, endDate) {
    return new Promise((resolve) => {
      this.firestore.collection('group', (ref) =>
        ref.where("corpId", "==", corpId)
          // .orderBy("timeStamp", "desc")
          .where("status", "in", ['Approved','Rejected'])
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getCorporateBanquetRequestSummary(corpId: any, startDate, endDate) {
    return new Promise((resolve) => {
      this.firestore.collection('banquet', (ref) =>
        ref.where("corpId", "==", corpId)
          // .orderBy("timeStamp", "desc")
          .where("status", "in", ['Approved','Rejected'])
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getCorporateTripExpenseSummary(corpId: any, startDate, endDate) {
    return new Promise((resolve) => {
      this.firestore
        .collection('tripSummary', (ref) =>
          ref
            .where('corpId', '==', corpId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getTripSummaryByRoomId(roomId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('tripSummary', (ref) => ref.where('roomId', '==', roomId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  gettripsummaryByBookingId(bookingId: any, corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('tripSummary', (ref) =>
          ref.where('id', '==', bookingId).where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getTripSummaryByGroupId(groupId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('tripSummary', (ref) => ref.where('roomId', '==', groupId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }
  getTripSummaryByBanquetId(banquetId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('tripSummary', (ref) =>
          ref.where('roomId', '==', banquetId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  upDateTripSummary(data: any) {
    data.timeStamp = moment().format('x');
    console.log('update data', data);
    debugger;
    return this.afs.doc('tripSummary/' + data.id).set(data);
  }

  // upDateTripSummary(id: string, data: any) {
  //   data.timeStamp = moment().format('x')
  //   return this.afs.doc('tripSummary/' + data.id).set(data);
  // }

  getFullCorporateTripSummary(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection(
          'tripSummary',
          (ref) => ref.where('corpId', '==', corpId)
          // .orderBy("timeStamp","desc")
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullCorporateTripSummaryByEmpId(empId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection(
          'tripSummary',
          (ref) =>
            ref
              .where('bookedBy.id', '==', empId)
              .where('status', 'in', ['Approved', 'confirmed', 'Confirmed'])
          // .orderBy("timeStamp","desc")
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullCorporateTripSummaryByEmpIdByDate(
    empId: any,
    startDate: any,
    endDate: any
  ) {
    return new Promise((resolve) => {
      this.firestore
        .collection(
          'tripSummary',
          (ref) =>
            ref
              .where('bookedBy.id', '==', empId)
              .where('status', 'in', ['Approved', 'confirmed', 'Confirmed'])
              .where('timeStamp', '>=', startDate)
              .where('timeStamp', '<=', endDate)
          // .orderBy("timeStamp","desc")
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullCorporateTripSummaryByManagerId(
    aprId: any,
    startDate: any,
    endDate: any
  ) {
    return new Promise((resolve) => {
      this.firestore
        .collection(
          'tripSummary',
          (ref) =>
            ref
              .where('managerId', '==', aprId)
              .where('status', 'in', ['Approved', 'confirmed', 'Confirmed'])
              .where('timeStamp', '>=', startDate)
              .where('timeStamp', '<=', endDate)
          // .orderBy("timeStamp","desc")
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullCorporateTripSummaryByRequestId(
    requestId: any,
    startDate: any,
    endDate: any
  ) {
    return new Promise((resolve) => {
      this.firestore
        .collection(
          'tripSummary',
          (ref) =>
            ref
              .where('requestId', '==', requestId)
              .where('status', 'in', ['Approved', 'confirmed', 'Confirmed'])
              .where('timeStamp', '>=', startDate)
              .where('timeStamp', '<=', endDate)
          // .orderBy("timeStamp","desc")
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAllRooms() {
    return new Promise((resolve) => {
      this.firestore
        .collection('room')
        .snapshotChanges()
        .subscribe((users) => {
          let roomList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(roomList);
        });
    });
  }

  getLinkedClientByCorpId(uid: any) {
    console.log(uid);
    return new Promise((resolve) => {
      this.firestore
        .collection('linkclients', (ref) =>
          ref
            .where('corpId', '==', uid)
            .where('status', '==', 'On-Boarding Completed')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getLeadByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('leadmanagement', (ref) =>
          ref.where('corpId', '==', corpId).orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAllGroups() {
    return new Promise((resolve) => {
      this.firestore
        .collection('group')
        .snapshotChanges()
        .subscribe((users) => {
          let groupList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(groupList);
        });
    });
  }

  getAllBanquets() {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet')
        .snapshotChanges()
        .subscribe((users) => {
          let groupList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(groupList);
        });
    });
  }

  getRoomsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref.where('status', '==', 'Pending').where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingRoomsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', 'in', [
              'Booked',
              'rejected',
              'offline_payment',
              'offline_payment_sentBack',
              'Expired',
            ])
            .where('corpId', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingRoomsAmendmentByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('corpId', '==', corpId)
            .where('hotelReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getRoomBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref.where('reqById', '==', userId).orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCommonRoomBookingByEmail(email: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('otherEmpList', 'array-contains', email)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }
  getCommonTripsByEmail(email: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('tripSummary', (ref) =>
          ref
            .where('otherEmpList', 'array-contains', email)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullRoomBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', 'in', [
              'Draft',
              'Pending',
              'Sent Back to Employee',
            ])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullLegsRoomBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', 'in', [
              'Draft',
              'Pending',
              'Sent Back to Employee',
            ])
            .where('reqById', '==', userId)
            .where('isLeg', '==', true)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }
  getFullLegsGroupBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('status', 'in', [
              'Draft',
              'Pending',
              'Sent Back to Employee',
            ])
            .where('reqById', '==', userId)
            .where('isLeg', '==', true)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getEmpRoomAmendmentByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('reqById', '==', userId)
            .where('empReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getGroupBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref.where('reqById', '==', userId).orderBy('bookedAt', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getEmpGroupAmendmentByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('reqById', '==', userId)
            // .where("empReqType", "==", 'Amendment')
            .where('empReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingGroupsAmendmentByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('corpId', '==', corpId)
            // .where("hotelReqType", "==", 'Amendment')
            .where('hotelReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingGroupBookingByUserId(userId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('status', 'in', ['Pending', 'Sent Back to Employee'])
            .where('reqById', '==', userId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullPendingGroupBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('status', 'in', [
              'Draft',
              'Pending',
              'Sent Back to Employee',
            ])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingBanquetBookingByUserId(userId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('status', 'in', ['Pending', 'Sent Back to Employee'])
            .where('reqById', '==', userId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingBanquetAmendmentByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('corpId', '==', corpId)
            // .where("hotelReqType", "==", 'Amendment')
            .where('hotelReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getEmpBanquetsAmendmentByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('reqById', '==', userId)
            // .where("empReqType", "==", 'Amendment')
            .where('empReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullPendingBanquetBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('status', 'in', [
              'Pending',
              'Draft',
              'Sent Back to Employee',
            ])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getBanquetBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref.where('reqById', '==', userId).orderBy('bookedAt', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getRoomBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref.where('managerId', '==', userId).orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullRoomBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) => ref.where('managerId', '==', userId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getGroupBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref.where('managerId', '==', userId).orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getBanquetBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref.where('managerId', '==', userId).orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingRoomBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            // .where("status", "in", ['Pending', 'Sent Back to Employee'])
            .where('status', 'in', ['Pending'])
            .where('managerId', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingRoomBookingByManagerIdForStats(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref.where('managerId', '==', userId).orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }
  getPendingGroupBookingByManagerIdForStats(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref.where('managerId', '==', userId).orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }
  getPendingBanquetBookingByManagerIdForStats(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref.where('managerId', '==', userId).orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingRoomAmendmentByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('managerId', '==', userId)
            .where('empReqType', '==', 'Amendment')
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingRoomCancellationByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('managerId', '==', userId)
            .where('empReqType', '==', 'Cancellation')
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingGroupCancellationByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('managerId', '==', userId)
            .where('empReqType', '==', 'Cancellation')
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingGroupBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            // .where("status", "in", ['Pending', 'Sent Back to Employee'])
            .where('status', 'in', ['Pending', 'Sent Back By Employee'])
            .where('managerId', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingGroupAmendmentByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('managerId', '==', userId)
            .where('empReqType', '==', 'Amendment')
            // .where("empReqType", "in", ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingBanquetAmendmentByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('managerId', '==', userId)
            .where('empReqType', '==', 'Amendment')
            // .where("empReqType", "in", ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingBanquetCancellationByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('managerId', '==', userId)
            .where('empReqType', '==', 'Cancellation')
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPendingBanquetBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            // .where("status", "in", ['Pending', 'Sent Back to Employee'])
            .where('status', 'in', ['Pending'])
            .where('managerId', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getUpdatedRoomBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', '==', 'Sent Back to Employee')
            .where('managerId', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getUpdatedGroupBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('status', '==', 'Sent Back to Employee')
            .where('managerId', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getUpdatedBanquetBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('status', '==', 'Sent Back to Employee')
            .where('managerId', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedRoomBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', 'in', ['Approved', 'confirmed', 'checkout'])
            .where('managerId', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApproverAmendmentRoomBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('managerId', '==', userId)
            .where('requestType', '==', 'Amendment')
            .where('status', 'in', ['Pending', 'Confirmed'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApproverAmendmentGroupBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('managerId', '==', userId)
            .where('requestType', '==', 'Amendment')
            .where('status', 'in', ['Pending', 'Confirmed'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedGroupBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', 'in', [
              'confirmed',
              'APPR_APPROVED',
              'TD_APPROVED',
              'CORP_ACCEPTED',
              'CORP_PAID',
              'HTL_AVLBL',
              'HTL_UPDATE_TARIFF',
            ])
            .where('managerId', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedBanquetBookingByManagerId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('statusType', 'in', [
              'confirmed',
              'APPR_APPROVED',
              'TD_APPROVED',
              'CORP_ACCEPTED',
              'CORP_PAID',
              'HTL_AVLBL',
              'HTL_UPDATE_TARIFF',
            ])
            .where('managerId', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getGroupReqByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('hotelList', 'array-contains', hotelId)
            .where('statusType', 'in', [
              'TD_APPROVED',
              'CORP_ACCEPTED',
              'HTL_UPDATE_TARIFF',
            ])
            //.where("status", "!=", 'Expired')
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getBanquetReqByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('hotelList', 'array-contains', hotelId)
            .where('statusType', 'in', [
              'TD_APPROVED',
              'CORP_ACCEPTED',
              'HTL_UPDATE_TARIFF',
            ])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  deleteGroupById(id) {
    return this.afs.doc('group/' + id).delete();
  }

  getGroupPendingRequestByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', 'in', [
              'TD_APPROVED',
              'CORP_ACCEPTED',
              'HTL_UPDATE_TARIFF',
            ])
            //  .where("status", "==", 'Expired')
            .where('corpId', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getBanquetPendingRequestByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('statusType', 'in', [
              'TD_APPROVED',
              'CORP_ACCEPTED',
              'Expired',
              'HTL_UPDATE_TARIFF',
            ])
            .where('corpId', '==', corpId)
            .orderBy('bookedAt', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getMultiApprovedGroupsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('multiGroup', (ref) =>
          ref
            .where('statusType', 'in', [
              'TD_APPROVED',
              'HTL_RJCT',
              'HTL_AVLBL',
              'HTL_UPDATE_TARIFF',
              'CORP_ACCEPTED',
            ])
            .where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorpApprovedGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', 'in', [
              'TD_APPROVED',
              'TD_ACCEPTED',
              'HTL_AVLBL',
              'CORP_ACCEPTED',
              'HTL_UPDATE_TARIFF',
            ])
            .where('hotelId', '==', hotelId)
            .orderBy('bookedAt', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorpApprovedGroupsByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', 'in', [
              'Pending',
              'Withdrawn',
              'APPR_APPROVED',
              'TD_APPROVED',
              'HTL_AVLBL',
              'HTL_RJCT',
              'CORP_ACCEPTED',
              'CORP_PAID',
              'CHECKOUT_DONE',
              'HTL_UPDATE_TARIFF',
            ])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorpGroupsDraftsByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', 'in', ['Draft'])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullCorpApprovedGroupsByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', 'in', [
              'Pending',
              'Withdrawn',
              'APPR_APPROVED',
              'TD_APPROVED',
              'HTL_AVLBL',
              'HTL_RJCT',
              'CORP_ACCEPTED',
              'CORP_PAID',
              'CHECKOUT_DONE',
              'HTL_UPDATE_TARIFF',
            ])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorpApprovedBanquetByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('statusType', 'in', [
              'Pending',
              'Withdrawn',
              'APPR_APPROVED',
              'TD_APPROVED',
              'HTL_AVLBL',
              'HTL_RJCT',
              'CORP_ACCEPTED',
              'CORP_PAID',
              'CHECKOUT_DONE',
              'HTL_UPDATE_TARIFF',
            ])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorpBanquetDraftsByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('statusType', 'in', ['Draft'])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullCorpApprovedBanquetByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('statusType', 'in', [
              'Pending',
              'Withdrawn',
              'APPR_APPROVED',
              'TD_APPROVED',
              'HTL_AVLBL',
              'HTL_RJCT',
              'CORP_ACCEPTED',
              'CORP_PAID',
              'CHECKOUT_DONE',
              'HTL_UPDATE_TARIFF',
            ])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedBanquetBookingByManagerId1(
    userId: any,
    startDate: any,
    endDate: any
  ) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('status', '==', 'Approved')
            .where('managerId', '==', userId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedRoomBookingByUserId(userId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', '==', 'Approved')
            .where('reqById', '==', userId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullApprovedRoomBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            // .where("status", "==", 'Approved')
            .where('status', 'in', ['Approved', 'Booked'])
            // .where("statusType", "in", ['Pending', 'Withdrawn', 'APPR_APPROVED', 'TD_APPROVED', 'HTL_AVLBL', 'HTL_RJCT', 'CORP_ACCEPTED', 'CORP_PAID', 'CHECKOUT_DONE', 'HTL_UPDATE_TARIFF'])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedRoomAmendmentByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('reqById', '==', userId)
            // .where("tdReqType", "==", 'Amendment')
            .where('tdReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedGroupAmendmentByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('reqById', '==', userId)
            // .where("tdReqType", "==", 'Amendment')
            .where('tdReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedGroupBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('status', '==', 'Approved')
            .where('reqById', '==', userId)
            .orderBy('bookedAt', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedBanquetBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('status', '==', 'Approved')
            .where('reqById', '==', userId)
            .orderBy('bookedAt', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getConfirmedRoomBookingByUserId(userId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', '==', 'confirmed')
            .where('reqById', '==', userId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullConfirmedRoomBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', 'in', ['confirmed', 'checkout'])
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getConfirmedAmendedRoomBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('reqById', '==', userId)
            .where('empAmendment.requestType', '==', 'Amendment')
            // .where("empAmendment.requestType", "==", 'Amendment')
            // .where("status", "in", ['Pending', 'Confirmed'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getConfirmedAmendedGroupBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('reqById', '==', userId)
            // .where("empAmendment.requestType", "==", 'Amendment')
            .where('empAmendment.requestType', 'in', [
              'Amendment',
              'Cancellation',
            ])
            // .where("status", "in", ['Pending', 'Confirmed'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getConfirmedAmendedBanquetBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('reqById', '==', userId)
            // .where("empAmendment.requestType", "==", 'Amendment')
            .where('empAmendment.requestType', 'in', [
              'Amendment',
              'Cancellation',
            ])
            // .where("status", "in", ['Pending', 'Confirmed'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getConfirmedBanquetBookingByUserId(
    userId: any,
    startDate: any,
    endDate: any
  ) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('status', '==', 'confirmed')
            .where('reqById', '==', userId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullConfirmedBanquetBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('status', '==', 'confirmed')
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedRoomBookingByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            // .where("statusType", "==", 'APPR_APPROVED')
            .where('status', '==', 'Approved')
            .where('corpId', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedAmendmentRoomBookingByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('corpId', '==', corpId)
            .where('tdReqType', 'in', ['Amendment', 'Cancellation'])
            // .where("tdReqType", "==", 'Amendment')
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedGroupBookingByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            // .where("statusType", "==", 'CORP_PAID')
            // .where("status", "in", ['confirmed', 'Confirmed', 'Approved'])
            .where('status', 'in', ['confirmed', 'Confirmed'])
            .where('corpId', '==', corpId)
            .orderBy('bookedAt', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedAmendmentGroupBookingByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('corpId', '==', corpId)
            .where('tdReqType', '==', 'Amendment')
            // .where("status", "in", ['Confirmed'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedAmendmentBanquetBookingByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('corpId', '==', corpId)
            .where('tdReqType', '==', 'Amendment')
            // .where("status", "in", ['Confirmed'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedBanquetBookingByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            // .where("statusType", "==", 'CORP_PAID')
            .where('status', 'in', ['confirmed', 'Confirmed'])
            .where('corpId', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getConfirmedGroupBookingByUserId(userId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', '==', 'CORP_PAID')
            .where('reqById', '==', userId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getFullConfirmedGroupBookingByUserId(userId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', '==', 'CORP_PAID')
            .where('reqById', '==', userId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApproverGroupBookingByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('statusType', '==', 'APPR_APPROVED')
            .where('corpId', '==', corpId)
            .orderBy('bookedAt', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApproverBanquetBookingByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('statusType', '==', 'APPR_APPROVED')
            .where('corpId', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedBanquetBookingByCorpId1(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('status', '==', 'Approved')
            .where('corpId', '==', corpId)
            .orderBy('bookedAt', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getBanquetByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref.where('status', '==', 'Pending').where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getPolicyByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('corppolicies', (ref) => ref.where('corpId', '==', corpId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getConfirmedRoomsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', 'in', [
              'confirmed',
              'Confirmed',
              'Approved',
              'checkout',
            ])
            .where('corpId', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCancelledRoomsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('corpId', '==', corpId)
            .where('statusType', '==', 'HTL_RJCT')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedRooms(corpId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', '==', 'Approved')
            .where('corpId', '==', corpId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let groupList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(groupList);
        });
    });
  }

  getRejectedRoomsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', '==', 'rejected')
            .where('corpId', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCancelledRooms(corpId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', '==', 'rejected')
            .where('corpId', '==', corpId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let groupList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(groupList);
        });
    });
  }

  getCancelledRoomsByHotelId(hotelId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', '==', 'rejected')
            .where('hotelId', '==', hotelId)
            .where('timeStamp', '>=', startDate)
            .where('timeStamp', '<=', endDate)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getRoomsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection(
          'room',
          (ref) =>
            ref
              // .where("status", "==", 'Booked')
              .where('status', 'in', [
                'Booked',
                'offline_payment',
                'offline_payment_sentBack',
              ])
              .where('hotelData.id', '==', hotelId)
          // .orderBy("timeStamp","desc")
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAmendmentRoomsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('hotelData.id', '==', hotelId)
            .where('hotelReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAmendmentGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('hotelData.id', '==', hotelId)
            .where('hotelReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('status', '==', 'Booked')
            .where('hotelData.hotelId', '==', hotelId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getBanquetByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref.where('status', '==', 'Booked').where('hotelId', '==', hotelId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAmendmentBanquetByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('hotelData.id', '==', hotelId)
            .where('hotelReqType', 'in', ['Amendment', 'Cancellation'])
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getActiveCorporate() {
    return new Promise((resolve) => {
      this.firestore
        .collection('corporate', (ref) =>
          ref.where('isProcessDone', '==', true)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getLiveCorporate() {
    return new Promise((resolve) => {
      this.firestore
        .collection('corporate', (ref) =>
          ref
            .where('status', '==', 'On-Boarding Completed')
            .where('isProcessDone', '==', true)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorporateByTenantId(tenantId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('corporate', (ref) =>
          ref.where('tenantId', '==', tenantId).orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getHotelByTenantId(tenantId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('hotels', (ref) => ref.where('tenantId', '==', tenantId))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getTripSummaryById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('tripSummary').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getCorporateById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('corporate').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            console.log(res);
            resolve(res);
          }
        })
        .catch(function (error) {
          console.log(error);
          resolve(null);
        });
    });
  }

  // this function get called when don't know doc id and we want to get the data of corporate by using UID which is present inside doc.
  getCorporateByUID(uid: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('corporate', (ref) => ref.where('UID', '==', uid))
        .snapshotChanges()
        .subscribe((users) => {
          let corporate = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(corporate);
        });
    });
  }

  getCorpPolicyById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('corppolicies').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getBudgetById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('corpBudget').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getJsonCorpEmpReqData(id) {
    return this.httpService.get(
      '../../assets/data/json-corpemp-bookingrequests.json',
      id
    );
  }

  getJsonCorpUserRegsData(id) {
    return this.httpService.get(
      '../../assets/data/json-corp-userreg-data.json',
      id
    );
  }

  getPendingTransactionById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('room').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getRoomById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('room').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getUserById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('admins').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getGroupsById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('group').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getBanquetById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('banquet').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getPendingGroupTransactionById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('group').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getPendingBanquetTransactionById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection('banquet').doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getAllCorporate() {
    return new Promise((resolve) => {
      this.firestore
        .collection('corporate')
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getRequestId(requestId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('corporate', (ref) =>
          ref.where('requestId', '==', parseInt(requestId))
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getRejectedBanquetByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('rejectedBanquet', (ref) =>
          ref.where('corpId', '==', corpId).orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  createRole(role: any) {
    return new Promise((resolve) => {
      if (role.id) {
        this.updateCurrRole(role).then(() => {
          resolve(role);
        });
      } else {
        this.newRole(role).then(() => {
          resolve(role);
        });
      }
    });
  }

  updateCurrRole(role: any) {
    role.timeStamp = moment().format('x');
    return this.afs.doc<any>('rolemanagement/' + role.id).set(role);
  }

  newRole(role: any) {
    role.timeStamp = moment().format('x');
    return this.roleCollection.add(role);
  }

  getJsonRequestsBookingData(id) {
    return this.httpService.get(
      '../../assets/data/json-requestbooking.json',
      id
    );
  }
  getJsonRequestBookingData() {
    return this.httpService.get('../../assets/data/json-requestbooking.json');
  }

  getJsonConfirmedBookingData() {
    return this.httpService.get('../../assets/data/json-confirmedbooking.json');
  }

  getJsonPendingBookingData() {
    return this.httpService.get('../../assets/data/json-pendingbooking.json');
  }

  getJsonGroupConfirmedBookingData() {
    return this.httpService.get(
      '../../assets/data/json-group-confirmed-data.json'
    );
  }

  getJsonGroupPendingBookingData() {
    return this.httpService.get(
      '../../assets/data/json-group-pending-data.json'
    );
  }

  getJsonBanquetBookingData() {
    return this.httpService.get(
      '../../assets/data/json-banquet-requests-data.json'
    );
  }

  getJsonBanquetConfirmedData() {
    return this.httpService.get(
      '../../assets/data/json-banquet-confirmed-data.json'
    );
  }

  getJsonBanquetPendingData() {
    return this.httpService.get(
      '../../assets/data/json-banquet-pending-data.json'
    );
  }
  getJsonTripSummaryData() {
    return this.httpService.get('../../assets/data/json-trip-data.json');
  }

  getJsonCorpMastersData() {
    return this.httpService.get('../../assets/data/json-corpmaster-data.json');
  }
  getJsonCorpPolicyData() {
    return this.httpService.get('../../assets/data/json-corppolicy-data.json');
  }

  getJsonCorpNewHotelData() {
    return this.httpService.get(
      '../../assets/data/json-corp-newhotel-data.json'
    );
  }
  getJsonCorpLinkHotelData() {
    return this.httpService.get(
      '../../assets/data/json-corp-linkhotel-data.json'
    );
  }
  getJsonCorpManageHotelData() {
    return this.httpService.get(
      '../../assets/data/json-corp-managehotel-data.json'
    );
  }

  getJsonCorpTravelRequestData() {
    return this.httpService.get(
      '../../assets/data/json-corp-travelrequest-data.json'
    );
  }
  getJsonCorpTravelBookingData() {
    return this.httpService.get(
      '../../assets/data/json-corp-travelbooking-data.json'
    );
  }
  getJsonCorpHotelWiseExpensesData() {
    return this.httpService.get(
      '../../assets/data/json-corp-hotelwiseexpense-data.json'
    );
  }
  getJsonCorpCityWiseExpensesData() {
    return this.httpService.get(
      '../../assets/data/json-corp-citywiseexpense-data.json'
    );
  }
  getJsonCorpEmployeeWiseExpensesData() {
    return this.httpService.get(
      '../../assets/data/json-corp-employeewiseexpense-data.json'
    );
  }
  getJsonCorpDeprtmentWiseExpensesData() {
    return this.httpService.get(
      '../../assets/data/json-corp-departwiseexpense-data.json'
    );
  }

  getJsonCorpUserRegData() {
    return this.httpService.get(
      '../../assets/data/json-corp-userreg-data.json'
    );
  }
  getJsonCorpSubscriberData() {
    return this.httpService.get(
      '../../assets/data/json-corp-subscriber-data.json'
    );
  }

  getJsonCorpApprovalSummaryData() {
    return this.httpService.get(
      '../../assets/data/json-corp-approvalsummary-data.json'
    );
  }
  getJsonCorpApprovedTripsData() {
    return this.httpService.get(
      '../../assets/data/json-corp-approvaltrips-data.json'
    );
  }
  getJsonCorpPendingApprovalSData() {
    return this.httpService.get(
      '../../assets/data/json-corp-pendingapproval-data.json'
    );
  }
  getJsonCorpTripSummaryData() {
    return this.httpService.get(
      '../../assets/data/json-corp-tripsummary-data.json'
    );
  }

  getJsonCorpEmpBookingReqData() {
    return this.httpService.get(
      '../../assets/data/json-corpemp-bookingrequests.json'
    );
  }

  getJsonCorpEmpReqSummaryData() {
    return this.httpService.get(
      '../../assets/data/json-corpemp-requestssummary.json'
    );
  }

  getJsonCorpEmpScheduleData() {
    return this.httpService.get(
      '../../assets/data/json-corpemp-scheduleconfirmed.json'
    );
  }

  getConfirmedGroupsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref.where('status', '==', 'confirmed').where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getApprovedGroupsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref.where('status', '==', 'Approved').where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getConfirmedBanquetByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref.where('status', '==', 'confirmed').where('corpId', '==', corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCorpAutoId() {
    return new Promise((resolve) => {
      let orderNumRef = this.afs.doc('settings/corporate');
      return orderNumRef.ref.get().then((doc) => {
        let val = '0001';
        if (doc.exists) {
          val = (Number(doc.data().counter) + 1).toString();
        }
        orderNumRef.ref.set({
          counter: val,
        });
        resolve(val);
      });
    });
  }

  getCorpLinkId() {
    return new Promise((resolve) => {
      let orderNumRef = this.afs.doc('settings/corporateLink');
      return orderNumRef.ref.get().then((doc) => {
        let val = '0001';
        if (doc.exists) {
          val = (Number(doc.data().counter) + 1).toString();
        }
        orderNumRef.ref.set({
          counter: val,
        });
        resolve(val);
      });
    });
  }

  getReqAutoId() {
    return new Promise((resolve) => {
      let orderNumRef = this.afs.doc('settings/roomReq');
      return orderNumRef.ref.get().then((doc) => {
        let val: any = 2100001;
        if (doc.exists) {
          val = (Number(doc.data().counter) + 1).toString();
        }
        orderNumRef.ref.set({
          counter: val,
        });
        resolve(val);
      });
    });
  }

  getTripAutoId() {
    return new Promise((resolve) => {
      let orderNumRef = this.afs.doc('settings/roomtrip');
      return orderNumRef.ref.get().then((doc) => {
        let val: any = 2100001;
        if (doc.exists) {
          val = (Number(doc.data().counter) + 1).toString();
        }
        orderNumRef.ref.set({
          counter: val,
        });
        resolve(val);
      });
    });
  }

  getBookingAutoId(maxCount?: any) {
    return new Promise((resolve) => {
      let orderNumRef = this.afs.doc('settings/roomBook');
      return orderNumRef.ref.get().then((doc) => {
        let val: any = 2100001;
        if (doc.exists) {
          val = (Number(doc.data().counter) + Number(maxCount || 1)).toString();
        }
        orderNumRef.ref.set({
          counter: val,
        });
        resolve(val);
      });
    });
  }

  getGroupBookingAutoId() {
    return new Promise((resolve) => {
      let orderNumRef = this.afs.doc('settings/groupBook');
      return orderNumRef.ref.get().then((doc) => {
        let val: any = 2100001;
        if (doc.exists) {
          val = (Number(doc.data().counter) + 1).toString();
        }
        orderNumRef.ref.set({
          counter: val,
        });
        resolve(val);
      });
    });
  }

  getBanquetBookingAutoId() {
    return new Promise((resolve) => {
      let orderNumRef = this.afs.doc('settings/banquetBook');
      return orderNumRef.ref.get().then((doc) => {
        let val: any = 2100001;
        if (doc.exists) {
          val = (Number(doc.data().counter) + 1).toString();
        }
        orderNumRef.ref.set({
          counter: val,
        });
        resolve(val);
      });
    });
  }

  getCheckOutByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', '==', 'checkout')
            .where('corporateData.id', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getGroupCheckOutByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('status', '==', 'checkout')
            .where('corporateData.id', '==', corpId)

            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getBanquetCheckOutByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('status', '==', 'checkout')
            .where('corporateData.id', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCheckOutByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', '==', 'checkout')
            .where('hotelData.id', '==', hotelId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getCheckOutListByHotelId(hotelId: any, corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('room', (ref) =>
          ref
            .where('status', '==', 'checkout')
            .where('hotelData.id', '==', hotelId)
            .where('corporateData.id', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getGroupCheckOutByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('group', (ref) =>
          ref
            .where('status', '==', 'checkout')
            .where('hotelData.id', '==', hotelId)

            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getBanquetCheckOutByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('banquet', (ref) =>
          ref
            .where('status', '==', 'checkout')
            .where('hotelData.id', '==', hotelId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getHotelReceivablesByHotelId(hotelId: any, corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection('hotelReceivables', (ref) =>
          ref
            .where('hotelId', '==', hotelId)
            .where('corpId', '==', corpId)
            .orderBy('timeStamp', 'desc')
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }
}
